<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="container-fluid">
                <div class="card">
                    <div class="card-body">
                        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
                            <span>{{messError}}</span>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="search-component d-flex flex-wrap">
                            <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                                <div class="col-sm-11 d-flex flex-column">
                                    <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                        <div class="col-sm-3">
                                            <InputTextNormal
                                                    :label="dataSearch.name.label"
                                                    :id="dataSearch.name.id"
                                                    :placeholder="dataSearch.name.placeholder"
                                                    :value-default="dataSearch.name.value"
                                                    @inputValue="onChange($event, dataSearch.name.id)"
                                                    :required="dataSearch.name.required"
                                            ></InputTextNormal>
                                        </div>
                                        <div class="col-sm-3">
                                            <InputTextNormal
                                                    :label="dataSearch.type.label"
                                                    :id="dataSearch.type.id"
                                                    :placeholder="dataSearch.type.placeholder"
                                                    :value-default="dataSearch.type.value"
                                                    @inputValue="onChange($event, dataSearch.type.id)"
                                                    :required="dataSearch.type.required"
                                            ></InputTextNormal>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-1 d-flex flex-column justify-content-end">
                                    <ButtonSearchComponent :label="labelButtonSearch" @click="searchMessages"></ButtonSearchComponent>
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-12 d-flex justify-content-between mt-4">
                            <div class="action d-flex align-items-center gap-3">
                                <div class="total">
                                    {{ CommonText.TOTAL_RECORD(listMessages.length, paginate.itemCount) }}
                                </div>
                                <div class="dropdown-action">
                                    <SelectCustom
                                            :label="selectAction.label"
                                            :id="selectAction.id"
                                            :placeholder="selectAction.placeholder"
                                            :value-default="selectAction.value"
                                            :required="selectAction.required"
                                            :options="selectAction.options"
                                            @action="actionSelect($event)"
                                    ></SelectCustom>
                                </div>
                            </div>
                            <div class="action-left d-flex align-items-center gap-3">
                                <div class="dropdown-action">
                                    <SelectCustom
                                            :label="selectLimitPage.label"
                                            :id="selectLimitPage.id"
                                            :placeholder="selectLimitPage.placeholder"
                                            :value-default="selectLimitPage.value"
                                            :required="selectLimitPage.required"
                                            :options="selectLimitPage.options"
                                            @action="actionLimitPage($event)"
                                    ></SelectCustom>
                                </div>
                            </div>
                        </div>
                        <div class="list-partners-component">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="listMessages.length > 0" v-for="message in listMessages" :key="message.id">
                                    <td class="message-name"><p @click="showMessageDetail(message.id)">{{message.name}}</p></td>
                                    <td>{{message.type}}</td>
                                    <td>{{message.description}}</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="3" class="text-center">Không có dữ lệu được tìm thấy!</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <PaginateComponent v-if="listMessages.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalMessageZaloComponent
        @showModal="eventClickShowModal($event)"
        :eventClickShowModal="isShowModal"
        :message="messageDetail"
></ModalMessageZaloComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>